import Api from './api';



export const getAll = async (hirerId) => { 
  let data = []
  await Api.get(`/alert/all`)
    .then(result => {
      data = result.data
    })
    .catch(err => {
      data = err
    })
  return data
};



